/**
 * Module Staff #03 — Devis & négociation
 */
const moduleStaffDevis = {
  id: 'staff-devis-negociation',
  population: 'staff',
  order: 3,
  category: 'Commercial',
  title: 'Devis & négociation',
  subtitle: 'Maîtriser le pricing, les négociations et la conversion',
  icon: 'DollarSign',
  duration: '25 min',
  level: 'Intermédiaire',
  audience: 'Commerciaux, opérateurs',
  slides: [
    { type: 'cover', eyebrow: 'Module 03 — Staff', title: 'Devis & négociation', subtitle: 'Optimiser votre taux de conversion', icon: 'DollarSign', duration: '25 min', audience: 'Commercial', level: 'Intermédiaire' },
    { type: 'intro', title: 'Objectifs', intro: 'La négociation est le cœur du métier commercial. Ce module vous donne tous les leviers pour gagner les deals.', objectives: [
      'Créer un devis avec calculateur intégré (distance, type, urgence)',
      'Comprendre les marges minimales par catégorie',
      'Gérer une négociation client avec contre-propositions',
      'Utiliser les modèles de devis pour gagner du temps',
      'Suivre votre taux de conversion individuel',
      'Identifier les leviers de marge (route, véhicule, fréquence)',
    ]},
    { type: 'concept', eyebrow: 'Pricing', icon: 'BookOpen', title: 'Comment se calcule un devis ?',
      bullets: [
        '📏 Distance : tarif au km selon zone (CEDEAO 15 pays)',
        '🚛 Type véhicule : plateau / citerne / frigo / porte-conteneurs',
        '⚖️ Poids/volume : majoration au-delà de la capacité standard',
        '⚡ Urgence : majoration 20-40 % pour livraison < 24 h',
        '🌍 Cross-border : frais douaniers + escortes',
        '💰 Marge cible : minimum 18 %, maximum 35 % selon segment',
      ],
      note: 'Le calculateur affiche en temps réel la marge prévisionnelle pour vous aider à arbitrer.',
    },
    { type: 'steps', title: 'Créer un devis en 4 minutes', steps: [
      { title: 'Bouton "+ Nouveau devis"', detail: 'Depuis la page Devis ou la fiche client.' },
      { title: 'Sélectionner ou créer le client', detail: 'Recherche par NCC ; nouveau = créer fiche complète.' },
      { title: 'Saisir trajet + marchandise', detail: 'Le calculateur met à jour le prix dynamiquement.' },
      { title: 'Ajuster avec la grille', detail: 'Possibilité de remise -10 % sans validation.' },
      { title: 'Vérifier la marge prévisionnelle', detail: 'Marge < 18 % → validation manager requise.' },
      { title: 'Envoyer le devis', detail: 'Email automatique avec PDF + lien d\'acceptation.' },
    ]},
    { type: 'steps', title: 'Gérer une négociation client', steps: [
      { title: 'Le client répond "Devis trop cher"', detail: 'Notification dans la messagerie.' },
      { title: 'Analyser la marge actuelle', detail: 'Combien puis-je céder ?' },
      { title: 'Faire une contre-proposition', detail: 'Bouton "Contre-proposition" sur le devis.' },
      { title: 'Argumenter la valeur ajoutée', detail: 'Délai, fiabilité, suivi GPS, assurance.' },
      { title: 'Si refus persistant', detail: 'Escalade au manager pour validation rabais > 10 %.' },
    ]},
    { type: 'comparison', title: 'Négociation : do vs don\'t', do: [
      'Toujours connaître votre marge minimale autorisée',
      'Argumenter la valeur, pas seulement le prix',
      'Proposer des contreparties (volume, durée, paiement)',
      'Documenter les concessions dans la messagerie',
      'Demander validation manager si marge < 18 %',
    ], dont: [
      'Ne jamais céder sans contrepartie',
      'Ne pas baisser sous la marge minimale sans accord',
      'Ne pas négocier par WhatsApp (pas de trace)',
      'Ne pas modifier le devis après acceptation client',
      'Ne pas surpromettre des délais intenables',
    ]},
    { type: 'quiz', title: 'Quiz #1',
      question: 'Un client demande -25 % sur votre devis. Votre marge actuelle est 22 %. Que faire ?',
      options: [
        'Refuser sans discuter',
        'Accepter pour ne pas perdre le client',
        'Demander validation manager (marge finale serait -3 %, sous le seuil)',
        'Inventer des frais cachés',
      ],
      answerIndex: 2,
      explanation: 'Avec -25 %, votre marge passerait à -3 % (perte). La validation manager est obligatoire pour évaluer si le volume/durée compense.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      'Marge minimale : 18 %.',
      'Argumenter valeur > argumenter prix.',
      'Contre-proposition = négociation gagnante.',
      'Toujours tracer dans la messagerie.',
      'Escalade manager < 18 %.',
    ]},
    { type: 'cta', title: 'Module 03 terminé !', actions: [
      { label: 'Page Devis', href: '/admin/quotes' },
      { label: 'Catalogue', href: '/docs/admin/training' },
    ]},
  ],
};
export default moduleStaffDevis;
